module.exports = __webpack_public_path__ + "static/arditi-hex-466b24935ac22e49a71d364845e8efbb.png";